import React from "react";
import { BiCheckCircle } from "react-icons/bi";
import { BsExclamationCircleFill } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import moment from "moment";

const ApprovalStatus = ({ approvals, currentUser }) => {
  return (
    <div className="p-6 bg-white shadow-lg rounded-lg overflow-x-auto">
      <h2 className="text-xl font-bold mb-6">Approvers</h2>
      <div className="flex items-center space-x-8">
        {approvals.map((approval, index) => {
          const isCurrentUser =
            currentUser &&
            (approval.name === currentUser.name ||
              approval.initials === currentUser.initials);

          return (
            <div
              key={index}
              className={`flex flex-col items-center min-w-[150px] space-y-2 ${
                isCurrentUser ? "bg-blue-100 rounded-lg p-4" : ""
              }`}
            >
              {/* Approver */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold ${
                    approval.status === "Approved"
                      ? "bg-green-500 text-white"
                      : approval.status === "Pending"
                        ? "bg-yellow-500 text-white"
                        : "bg-red-500 text-white"
                  } ${isCurrentUser ? "ring-4 ring-blue-500" : ""}`}
                >
                  {approval.initials}
                </div>
                <div className="text-center mt-2">
                  <p
                    className={`text-sm font-semibold ${
                      isCurrentUser ? "text-blue-800" : "text-gray-700"
                    }`}
                  >
                    {approval.name}
                  </p>
                  <p className="text-xs text-gray-500">{approval.role}</p>
                  <p className="text-xs text-gray-400">
                    {approval.status === "Pending"
                      ? `Since ${moment(approval.timestamp).fromNow()}`
                      : moment(approval.timestamp).format(
                          "MMM DD, YYYY hh:mm A"
                        )}
                  </p>
                </div>
              </div>

              {/* Comment Section */}
              {approval.comment && (
                <div className="p-2 bg-gray-100 rounded-lg shadow text-xs text-gray-700 w-full text-center">
                  <span className="font-semibold">Comment:</span>{" "}
                  {approval.comment}
                </div>
              )}

              {/* Arrow or Status Icon */}
              {index < approvals.length - 1 && (
                <div className="flex items-center justify-center w-full">
                  {approval.status === "Approved" && (
                    <BiCheckCircle className="text-green-500 text-xl" />
                  )}
                  {approval.status === "Pending" && (
                    <BsExclamationCircleFill className="text-yellow-500 text-xl" />
                  )}
                  {approval.status === "Rejected" && (
                    <MdCancel className="text-red-500 text-xl" />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ApprovalStatus;
